import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, CardBody, CardHeader, Col, Container, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row} from "reactstrap";
import * as moment from "moment";
import {Link} from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import DeleteModal from "../../../Components/Common/DeleteModal";
import {isEmpty} from "lodash";

// Formik
import * as Yup from "yup";
import {useFormik} from "formik";

//redux
import {useDispatch, useSelector} from "react-redux";

import {
  addNewSettlementPrice as onAddNewSettlementPrice,
  deleteSettlementPrice as onDeleteSettlementPrice,
  getClients as onGetClients,
  getSettlementPrices as onGetSettlementPrices,
  getUnits as onGetUnits,
  updateSettlementPrice as onUpdateSettlementPrice,
} from "../../../slices/thunks";


import Loader from "../../../Components/Common/Loader";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import {createSelector} from "reselect";
import {useProfile} from "../../../Components/Hooks/UserHooks";

const SettlementPricesManagement = () => {


  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  const [clients, setClients] = useState([]);
  const [units, setUnits] = useState([]);


  const dispatch = useDispatch();

  const selectLayoutState = (state) => state.SettlementPrices;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (set_price) => ({
      settlementPrices: set_price.settlementPrices, // Use settlementPrices instead of settlementPrice
      isSettlementPriceSuccess: set_price.isSettlementPriceSuccess,
      error: set_price.error,
    })
  );
  // Inside your component
  const {
    settlementPrices, // Use settlementPrices here
    isSettlementPriceSuccess,
    error
  } = useSelector(selectLayoutProperties);

  const { userProfile } = useProfile();

  useEffect(() => {
      dispatch(onGetClients()).then((response) => {
        setClients(response.payload || []);
      });
      dispatch(onGetUnits()).then((response) => {
        setUnits(response.payload || []);
      });
  }, [dispatch]);

  const isAdmin = userProfile?.user?.groups?.includes("Admin")||  userProfile?.user?.groups?.includes("Editor");
  const [settlementPriceList, setSettlementPriceList] = useState([]);
  const [settlementPrice, setSettlementPrice] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (settlementPrice) => {
    setSettlementPrice(settlementPrice);
    setDeleteModal(true);
  };

  const handleDeleteSettlementPrice = () => {
    if (settlementPrice) {
      dispatch(onDeleteSettlementPrice({settlementPriceId:settlementPrice.id}));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setSettlementPriceList(settlementPrices);
  }, [settlementPrices]);

  useEffect(() => {
    if (!isEmpty(settlementPrices)) setSettlementPriceList(settlementPrices);
  }, [settlementPrices]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSettlementPrices = settlementPrices;
      if (type !== "all") {
        filteredSettlementPrices = settlementPrices.filter((price) => price.status === type);
      }
      setSettlementPriceList(filteredSettlementPrices);
    }
  };

  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id:(settlementPrice && settlementPrice.id) || '',
      balance: (settlementPrice && settlementPrice.balance) || '',
      contract_pvc_number: (settlementPrice && settlementPrice.contract_pvc_number) || '',
      created_at: (settlementPrice && settlementPrice.created_at) || '',
      active: (settlementPrice && settlementPrice.active) || '',
      unit: (settlementPrice && settlementPrice.unit) || '',
      client: (settlementPrice && settlementPrice.client) || true,
    },
    validationSchema: Yup.object({
      balance: Yup.string().required("Please Enter Balance"),
      contract_pvc_number: Yup.string().required("Please Enter Contract PVC Number"),
      unit: Yup.string().required("Please Enter Unit"),
      client: Yup.string().required("Please Enter Client"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updatedSettlementPrice = {
          id: settlementPrice ? settlementPrice.id : 0,
          balance: values.balance,
          contract_pvc_number: values.contract_pvc_number,
          active: values.active,
          unit: values.unit,
          client: values.client,
        };
        dispatch(onUpdateSettlementPrice(updatedSettlementPrice));
        validation.resetForm();
      } else {
        const newSettlementPrice = {
          balance: values.balance,
          contract_pvc_number: values.contract_pvc_number,
          active: values.active,
          unit: values.unit,
          client: values.client,
        };
        dispatch(onAddNewSettlementPrice(newSettlementPrice));
        validation.resetForm();
      }
      toggle();
    },
  });

  useEffect(() => {
      dispatch(onGetSettlementPrices());
  }, [dispatch]);

  useEffect(() => {
    setSettlementPrice(settlementPrices);
  }, [settlementPrices]);

  useEffect(() => {
    if (!isEmpty(settlementPrices)) {
      setSettlementPrice(settlementPrices);
      setIsEdit(false);
    }
  }, [settlementPrices]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSettlementPrice(null);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);


  const handleSettlementPriceClicks  = () => {
    setSettlementPrice("");
    setIsEdit(false);
    toggle();
  };

  const handleSettlementPriceClick = useCallback((arg) => {
    const settlementPrice = arg;

    const associatedUnit = units.find((unit) => unit.id === settlementPrice.unit);
    const associatedClient = clients.find((client) => client.id === settlementPrice.client);

    // Ensure unit and client are available
    if (!associatedUnit || !associatedClient) {
      toast.error("Unit or Client data is not loaded yet. Please try again later.");
      return;
    }

    setSettlementPrice({
      id: settlementPrice.id,
      balance: settlementPrice.balance,
      contract_pvc_number: settlementPrice.contract_pvc_number,
      created_at: settlementPrice.created_at,
      active: settlementPrice.active,
      unit: settlementPrice.unit,
      client: settlementPrice.client,
    });

    setIsEdit(true);
    toggle();
  }, [toggle, units, clients]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = () => {
    const checkall = document.getElementById("checkBoxAll");
    selectedCheckBoxDelete.forEach((element) => {
      dispatch(onDeleteOrder(element.value));
      setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
    });
    setIsMultiDeleteButton(false);
    checkall.checked = false;
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".orderCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };


  // Column
  const columns = useMemo(
    () => [
      {
        header: "Balance",
        accessorKey: "balance",
        enableColumnFilter: false,
      },
      {
        header: "Contract Pvc Number",
        accessorKey: "contract_pvc_number",
        enableColumnFilter: false,
      },
      {
        header: "Created At",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {handleValidDate(cell.getValue())},
            <small className="text-muted"> {handleValidTime(cell.getValue())}</small>
          </>
        ),
      },
      {
        header: "Unit",
        accessorKey: "unit",
        enableColumnFilter: false,
        cell: (cell) => {
          const unitId = cell.getValue();
          const unit = units.find((u) => u.id == unitId);
          return unit ? unit.id : <span style={{ color: "red" }}>Unit not found</span>;
        },
      },
      {
        header: "Client",
        accessorKey: "client",
        enableColumnFilter: false,
        cell: (cell) => {
          const clientId = cell.getValue();
          const client = clients.find((c) => c.id === clientId);
          return client ? client.name : <span style={{ color: "red" }}>Client not found</span>;
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          const isAdmin = userProfile?.user?.groups?.includes("Admin")||  userProfile?.user?.groups?.includes("Editor");

          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
              <Link
                to={`/settlement-details/${cellProps.row.original.id}`}
                className="text-primary d-inline-block"
              >
                <i className="ri-eye-fill fs-16"></i>
              </Link>
              </li>
              {isAdmin && (
                <>
                  <li className="list-inline-item edit">
                    <Link
                      to="#"
                      className="text-primary d-inline-block edit-item-btn"
                      onClick={() => {
                        const settelementData = cellProps.row.original;
                        handleSettlementPriceClick(settelementData);
                      }}
                    >
                      <i className="ri-pencil-fill fs-16"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="#"
                      className="text-danger d-inline-block remove-item-btn"
                      onClick={() => {
                        const settelementData = cellProps.row.original;
                        onClickDelete(settelementData);
                      }}
                    >
                      <i className="ri-delete-bin-5-fill fs-16"></i>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          );
        },
      },
    ],
    [handleSettlementPriceClick, checkedAll]
  );

  const defaultdate = () => {
    let d = new Date(),
    months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let h = (d.getHours() % 12) || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return ((d.getDate() + ' ' + months[d.getMonth()] + ', ' + d.getFullYear() + ", " + h + ":" + d.getMinutes() + " " + ampm).toString());
  };


  const handleValidDate = date => {
    return moment(new Date(date)).format("DD MMM Y");
  };

  const handleValidTime = (time) => {
    const time1 = new Date(time);
    const getHour = time1.getUTCHours();
    const getMin = time1.getUTCMinutes();
    const getTime = `${getHour}:${getMin}`;
    var meridiem = "";
    if (getHour >= 12) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
    const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
    return updateTime;
  };

  const [isExportCSV, setIsExportCSV] = useState(false);

  return (
    <div className="page-content">
      <ExportCSVModal
        show={isExportCSV}
        onCloseClick={() => setIsExportCSV(false)}
        data={settlementPriceList}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteSettlementPrice}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Settlement Price" pageTitle="Tables" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    {/* <h5 className="card-title mb-0">Settlement Price</h5> */}
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      {isAdmin && <button
                        type="button"
                        className="btn btn-success add-btn"
                        id="create-btn"
                        onClick={() => { setIsEdit(false); toggle(); }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Create
                        Settlement
                      </button>}
                      <button type="button" className="btn btn-info" onClick={() => setIsExportCSV(true)}>
                        <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                        Export
                      </button>
                      {" "}
                      {isMultiDeleteButton && <button className="btn btn-soft-danger"
                        onClick={() => setDeleteModalMulti(true)}
                      ><i
                        className="ri-delete-bin-2-line"></i></button>}
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  <Nav
                    className="nav-tabs nav-tabs-custom nav-success"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "1" })}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-store-2-fill me-1 align-bottom"></i>{" "}
                        Settlement Prices
                      </NavLink>
                    </NavItem>
                  </Nav>
                  {isSettlementPriceSuccess ? (
                    clients.length === 0 ? (
                      <div className="text-center mt-5">
                        <p className="text-danger">No clients are available. Please add a client before managing settlement prices.</p>
                      </div>
                    ) : units.length === 0 ? (
                      <div className="text-center mt-5">
                        <p className="text-danger">No units are available. Please add a unit before managing settlement prices.</p>
                      </div>
                    ) : settlementPriceList.length > 0 ? (
                      <TableContainer
                        columns={columns}
                        data={(settlementPriceList || [])}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={20}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-muted text-uppercase"
                        handleSettlementPriceClick={handleSettlementPriceClick}
                        isSettelementPriceFilter={true}
                        SearchPlaceholder="Search for  ID, contract_pvc_number,  status or something..."
                      />
                    ) : (
                      <div className="text-center mt-5">
                        <p className="text-muted">No settlement prices are introduced yet. Please add a new settlement price.</p>
                      </div>
                    )
                  ) : (
                    <Loader error={error} />
                  )}
                </div>
                <Modal id="showModal" isOpen={modal} toggle={toggle} centered>
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Settlement Price" : "Add Settlement Price"}
                  </ModalHeader>

                  <Form className="tablelist-form" onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}>
                    <ModalBody>
                      <input type="hidden" id="id-field" />

                      <div className="mb-3">
                        <Label
                          htmlFor="id-field"
                          className="form-label"
                        >
                          Balance
                        </Label>
                        <Input
                          name="balance"
                          id="id-field"
                          className="form-control"
                          placeholder="Enter Balance"
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.balance || ""}
                          invalid={
                            validation.touched.balance && validation.errors.balance ? true : false
                          }
                        />
                        {validation.touched.balance && validation.errors.balance ? (
                          <FormFeedback type="invalid">{validation.errors.balance}</FormFeedback>
                        ) : null}

                      </div>

                      <div className="mb-3">
                        <Label
                          htmlFor="customername-field"
                          className="form-label"
                        >
                          Contract Pvc Number
                        </Label>
                        <Input
                          name="contract_pvc_number"
                          id="customername-field"
                          className="form-control"
                          placeholder="Enter Name"
                          type="number"
                          step="1"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contract_pvc_number || ""}
                          invalid={
                            !!(validation.touched.contract_pvc_number && validation.errors.contract_pvc_number)
                          }
                        />
                        {validation.touched.contract_pvc_number && validation.errors.contract_pvc_number ? (
                          <FormFeedback type="invalid">{validation.errors.contract_pvc_number}</FormFeedback>
                        ) : null}

                      </div>
                      <div className="mb-3">
                        <Label htmlFor="client-field" className="form-label">
                          Select Client
                        </Label>
                        <Input
                          name="client"
                          id="client-field"
                          type="select"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.client || ""}
                          invalid={!!(validation.touched.client && validation.errors.client)}
                        >
                          <option value="">Select a Client</option>
                          {clients.map((client) => (
                            <option key={client.id} value={client.id}>
                              {client.name}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.client && validation.errors.client ? (
                          <FormFeedback type="invalid">{validation.errors.client}</FormFeedback>
                        ) : null}
                      </div>

                      {/* Unit Dropdown */}
                      <div className="mb-3">
                        <Label htmlFor="unit-field" className="form-label">
                          Select Unit
                        </Label>
                        <Input
                          name="unit"
                          id="unit-field"
                          type="select"
                          className="form-select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.unit || ""}
                          invalid={!!(validation.touched.unit && validation.errors.unit)}
                        >
                          <option value="">Select a Unit</option>
                          {units.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.id}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.unit && validation.errors.unit ? (
                          <FormFeedback type="invalid">{validation.errors.unit}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label htmlFor="delivered-status" className="form-label">
                          Active
                        </Label>

                        <Input
                          name="active"
                          type="select"
                          className="form-select"
                          onChange={(e) => validation.setFieldValue('active', e.target.value === 'true')}
                          onBlur={validation.handleBlur}
                          value={validation.values.active !== undefined ? (validation.values.active ? "true" : "false") : "true"}
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </Input>

                        {validation.touched.active && validation.errors.active ? (
                          <FormFeedback type="invalid">
                            {validation.errors.active}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>

                        <button type="submit" className="btn btn-success">
                          {!!isEdit
                            ? "Update"
                            : "Add Settlement Price"}
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ToastContainer closeButton={false} limit={1}  />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SettlementPricesManagement;


